import script from "./LoanRequest.vue?vue&type=script&setup=true&lang=js"
export * from "./LoanRequest.vue?vue&type=script&setup=true&lang=js"

import "./LoanRequest.vue?vue&type=style&index=0&id=5ae27531&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ae27531"]])

export default __exports__